// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3nEtm","header":"PatientQuestionnaire_header__2Gf0j","info":"PatientQuestionnaire_info__zdgWD"};